export default "__VITE_ASSET__ed6dad9f__"